import angular from 'angular';

let notificationStreamIcon = angular
    .module("notificationStreamIcon", ['robloxApp', 'notificationStream', "notificationStreamIconHtmlTemplate"]);


export default notificationStreamIcon;